// extracted by mini-css-extract-plugin
module.exports = {"image":"_1SQyl","filter-effect-svg":"_1jWBE","filterEffectSvg":"_1jWBE","shapeCrop":"_1ShVK"};